import { render, staticRenderFns } from "./VotingModal.vue?vue&type=template&id=699caa30"
import script from "./VotingModal.vue?vue&type=script&lang=js"
export * from "./VotingModal.vue?vue&type=script&lang=js"
import style0 from "./VotingModal.vue?vue&type=style&index=0&id=699caa30&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports